// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    analyzeSalesTextAfter: {
        type: FIELD_TYPES.TEXT,
        label: "Analyze Sales Text After",
        translatable: true
    },
    analyzeSalesTextBefore: {
        type: FIELD_TYPES.TEXT,
        label: "Analyze Sales Text Before",
        translatable: true
    },
    buildACompetitorTextAfter: {
        type: FIELD_TYPES.TEXT,
        label: "Build A Competitor Text After",
        translatable: true
    },
    buildACompetitorTextBefore: {
        type: FIELD_TYPES.TEXT,
        label: "Build A Competitor Text Before",
        translatable: true
    },
    craftEmailTextAfter: {
        type: FIELD_TYPES.TEXT,
        label: "Craft Email Text After",
        translatable: true
    },
    craftEmailTextBefore: {
        type: FIELD_TYPES.TEXT,
        label: "Craft Email Text Before",
        translatable: true
    },
    createProjectTextAfter: {
        type: FIELD_TYPES.TEXT,
        label: "Create Project Text After",
        translatable: true
    },
    createProjectTextBefore: {
        type: FIELD_TYPES.TEXT,
        label: "Create Project Text Before",
        translatable: true
    },
    createTicketTextAfter: {
        type: FIELD_TYPES.TEXT,
        label: "Create Ticket Text After",
        translatable: true
    },
    createTicketTextBefore: {
        type: FIELD_TYPES.TEXT,
        label: "Create Ticket Text Before",
        translatable: true
    },
    generateAssetsTextAfter: {
        type: FIELD_TYPES.TEXT,
        label: "Generate Assets Text After",
        translatable: true
    },
    generateAssetsTextBefore: {
        type: FIELD_TYPES.TEXT,
        label: "Generate Assets Text Before",
        translatable: true
    },
    researchVenuesTextAfter: {
        type: FIELD_TYPES.TEXT,
        label: "Research Venues Text After",
        translatable: true
    },
    researchVenuesTextBefore: {
        type: FIELD_TYPES.TEXT,
        label: "Research Venues Text Before",
        translatable: true
    },
    analyzeSalesImgUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Analyze Sales IMG URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    competitorIntelligenceImgUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Competitor Intelligence IMG URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    craftEmailImgUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Craft Email IMG URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    generateAssetsImgUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Generate Assets IMG URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    projectPlanImgUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Project Plan IMG URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    researchVenuesImgUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Research Venues IMG URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    ticketRoutingImgUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Ticket Routing IMG URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    }
};
